<template>

  <div id="teachingRoom"></div>

</template>

<script>

  // 本地运行 this.$AgoraEdu.AgoraEduSDK
  // 开发环境 AgoraEduSDK


  import {domain} from '../../../../package.json'
  import {AgoraEduSDK} from 'agora-classroom-sdk'
  // import visible from "../../../plugins/visible.vue"
  import Vue from "vue";

  var timer = null;
  var boardAutoOpenTimer = null;
  var boardWidgetLoader = null;
  const BOARD_WIDGET_SCRIPT_ID = 'agora-board-widget-script';
  const BOARD_WIDGET_SCRIPT_SRC = '/static/agora-plugin-gallery/2.9.40/edu_widget.bundle.js';

  const getBoardWidgetClass = () => {
    return window.FcrBoardWidget || (window.AgoraWidgetGallery && window.AgoraWidgetGallery.FcrBoardWidget);
  };
  const getHXChatWidgetClass = () => {
    return window.AgoraHXChatWidget || (window.AgoraWidgetGallery && window.AgoraWidgetGallery.AgoraHXChatWidget);
  };
  const getWidgetName = (WidgetClass, fallbackName) => {
    try {
      const name = Object.create(WidgetClass.prototype).widgetName;
      return name || fallbackName;
    } catch (e) {
      return fallbackName;
    }
  };

  export default {
    // components: {visible },

    $title: '在线教学2',
    $icon: 'el-icon-data-board',
    // $route_path: 'teachingroom/:room',
    name: 'teachingRoom',
    data() {
      return {
        visible: false,
        // beginOfWeekDay:[],
        form: {
          // 你的声网 token，生成token的uid需要和userUuid一致
          token: "",
          rtmToken: "",
          userUuid: '', // 你的用户全局唯一标识
          userName: '111',  // 用户名称
          // this.$route.params.room
          roomUuid: this.$route.params.room, // 你的房间全局唯一标识，互通需要双方进入同一个房间
          roomName: `录制: ${this.$route.params.room}`,
          // 正常上课默认老师(1)，仅录制页(videoBitrate)使用观众(0)。
          roleType: this.$route.query.videoBitrate ? 0 : 1, // 用户课堂角色
          roomType: 0, // 1v1 课堂类型
          pretest: !this.$route.query.videoBitrate, // 录制页不做设备检测
          // !!this.$route.query.type
          language: "zh",
          startTime: '',
          roomProperties: {
            schedule: {
              closeDelay: 1200
            }
          },
          duration: 2400,  // 课堂的持续时间，课堂会在指定时间自动结束
          courseWareList: [],
          personalCourseWareList: [],
          // ${domain}
          // https://nba.hupu.com/
          // ${domain}/admin/teachingroom/${this.$route.params.room}?videoBitrate=8000
          recordUrl: `${domain}/#/admin/teachingroom/${this.$route.params.room}?videoBitrate=8000`,  // 待录制 URL 地址
          listener: (evt, params) => {  //获取录制状态  1：正常开始录制  2：正常停止录制
            console.log("监听", evt, params, this.$route.query.type, !this.$route.query.type)
            if (evt === 1 && Boolean(this.$route.query.type)) {
              // 通知服务器端录制页面已完全加载。
              // window.setInterval(() => {
              //   setTimeout(fun, 0)
              // }, 5000)
              timer = setInterval(() => {
                setTimeout(() => {
                  this.$api.videoReady({roomUuid: this.$route.params.room}).then(res => {
                    if (res.data.data.statusCode === 200) this.startVideo();
                  })
                }, 0)
              }, 5000);
            }
            if (evt === 2 && Boolean(this.$route.query.type)) {
              clearInterval(timer);
              this.$api.videoStop({cid: this.$route.params.room, sid: this.subject_id}).then(() => {
                console.log('停止录制', this.subject_id)
                this.$store.commit('updateIsTeaching', false);
                clearInterval(timer);
                this.$router.back();
              })
            }
            if (evt === 2 && !this.$route.query.type) {
              this.$store.commit('updateIsTeaching', false);
              this.$router.back();
            }
          }
        },
        pagination: {
          loading: false,
          subject_id: '',
          roomId: this.$route.params.room
        },
        joined: false,
        records: {},
        durMin: 0,
        subject_id: '',
        beforeUnloadTime : ''
        // AgoraRTC:''
      }
    },
    computed: {
      userinfo() {
        return this.$store.state.userinfo
      }
    },
    mounted() {
      // 官方示例中白板 widget 在部分场景需要完整刷新后才能正常挂载
      if (window.__netlessJavaScriptLoader && !sessionStorage.getItem('teachingRoomWidgetReloaded')) {
        sessionStorage.setItem('teachingRoomWidgetReloaded', '1');
        window.location.reload();
        return;
      }
      sessionStorage.removeItem('teachingRoomWidgetReloaded');

      this.$store.commit('updateIsTeaching', true);
      if (this.$route.query.type) {
        this.getRecords();
      } else {
        this.form.userUuid = Math.round(Math.random() * 100).toString();
        this.setupClassroom();
      }
      // 监听浏览器关闭，需要更新状态
        window.addEventListener("unload", this.unloadHandler);
    },
    methods: {
      ensureBoardWidgetLoaded() {
        const widgetClass = getBoardWidgetClass();
        if (widgetClass) {
          return Promise.resolve(widgetClass);
        }
        if (boardWidgetLoader) {
          return boardWidgetLoader;
        }
        boardWidgetLoader = new Promise((resolve, reject) => {
          const existingScript = document.getElementById(BOARD_WIDGET_SCRIPT_ID);
          if (existingScript) {
            existingScript.addEventListener('load', () => resolve(getBoardWidgetClass()));
            existingScript.addEventListener('error', reject);
            return;
          }

          const script = document.createElement('script');
          script.id = BOARD_WIDGET_SCRIPT_ID;
          script.src = BOARD_WIDGET_SCRIPT_SRC;
          script.async = true;
          script.onload = () => {
            const loadedWidgetClass = getBoardWidgetClass();
            if (loadedWidgetClass) {
              resolve(loadedWidgetClass);
            } else {
              reject(new Error('FcrBoardWidget load failed'));
            }
          };
          script.onerror = reject;
          document.head.appendChild(script);
        }).catch((error) => {
          boardWidgetLoader = null;
          console.error('白板 widget 加载失败', error);
          throw error;
        });
        return boardWidgetLoader;
      },
      getRecords() {
        this.pagination.loading = true;
        this.$api.courseList(this.pagination).then(({data: res}) => {
          this.records = res.data.list[0];
          this.form.userUuid = this.records.volunteer_id; // 你的用户全局唯一标识
          this.form.userName = this.records.volunteer_nickname;  // 用户名称
          this.form.roomName = this.records.subject_remark;
          this.form.startTime = new Date(this.records.start_time).getTime();
          this.form.duration = (((new Date(this.records.end_time).getTime()) - (new Date(this.records.start_time).getTime())) / 1000) + 3600;
          // this.durMin + 3600
          this.subject_id = this.records.subject_id
          let scenseList = []
          this.$api.coursewareList({cid: this.$route.params.room}).then(({data: res}) => {
            if (res.data.list.length > 0) {
              scenseList = [];
              this.form.courseWareList = res.data.list.map(o => {
                o.resourceName = o.name;
                o.resourceUuid = o.fid;
                o.ext = o.name ? `${o.name.split('.').pop()}` : '';
                o.fileurl = o.url;
                o.url = ["ppt", "pptx", "doc", "docx", "pdf"].includes(`${o.ext}`) ? null : o.url;
                ["ppt", "pptx", "doc", "docx", "pdf"].includes(`${o.ext}`) ? o.scenes = [{
                  name: `${o.name}`,
                  ppt: {
                    name: `${o.name}`,
                    src: `${o.fileurl}`,
                    width: 480,
                    height: 360
                  },
                  pptx: {
                    name: `${o.name}`,
                    src: `${o.fileurl}`,
                    width: 480,
                    height: 360
                  },
                  doc: {
                    name: `${o.name}`,
                    src: `${o.fileurl}`,
                    width: 480,
                    height: 360
                  },
                  docx: {
                    name: `${o.name}`,
                    src: `${o.fileurl}`,
                    width: 480,
                    height: 360
                  },
                  pdf: {
                    name: `${o.name}`,
                    src: `${o.fileurl}`,
                    width: 480,
                    height: 360
                  }
                }] : o.scenes = [];
                o.size = '';
                o.updateTime = '';
                o.taskUuid = "123";
                o.taskToken = "xxx";
                o.taskProgress = '';
                return o;
              })
            }
            this.setupClassroom();
          })
        })
      },
      setupClassroom() {
        // this.startVideo();
        if (!this.joined) {
          this.$api.agoraToken({
            channel: this.$route.params.room,
            uid: this.form.userUuid,
            type: this.$route.query.type
          }).then(async ({data: res}) => {
            this.$store.commit('updateTimer', this.timer)
            // 新版 SDK 使用 token 字段，保留 rtmToken 做兼容。
            const classroomToken = res.data.token || res.data.rtmToken;
            this.form.token = classroomToken;
            this.form.rtmToken = classroomToken;
            const BoardWidgetClass = await this.ensureBoardWidgetLoaded();
            this.$nextTick(() => {
              let eduSDK = AgoraEduSDK || window.AgoraEduSDK
              eduSDK.config({
                appId: res.data.appID,
                region: 'CN'
              })
              const boardWidgetName = getWidgetName(BoardWidgetClass, 'netlessBoard');
              const HXChatWidgetClass = getHXChatWidgetClass();
              const widgets = {
                [boardWidgetName]: BoardWidgetClass
              };
              if (HXChatWidgetClass) {
                const chatWidgetName = getWidgetName(HXChatWidgetClass, 'agoraHXChatWidget');
                widgets[chatWidgetName] = HXChatWidgetClass;
              } else {
                console.warn('AgoraHXChatWidget 未加载，右下角消息组件可能不显示');
              }
              const launchOptions = Object.assign({}, this.form, {
                roleType: Number(this.form.roleType),
                roomType: 0,
                pretest: Number(this.form.roleType) !== 0,
                token: this.form.token || this.form.rtmToken,
                widgets,
                recordRetryTimeout: 60,
                platform: "PC"
              });
              eduSDK.launch(document.querySelector("#teachingRoom"), launchOptions);
              this.autoOpenWhiteboard();
              // 本地
              /*AgoraEduSDK.config({
                appId: res.data.appID,
              })
              AgoraEduSDK.launch(document.querySelector("#teachingRoom"), this.form);*/
            });
          })

          // setTimeout(() =>{
          //   this.startVideo();
          // },5000);
        }
      },
      startVideo() {
        this.$api.videoStart(this.form).then(res => {
          // if(res.data.data.statusCode  === 200) {clearInterval(timer);}
        })
      },
      autoOpenWhiteboard() {
        if (Number(this.form.roleType) !== 1) {
          return;
        }
        let attempts = 0;
        clearInterval(boardAutoOpenTimer);
        boardAutoOpenTimer = setInterval(() => {
          attempts += 1;
          const toolCount = document.querySelectorAll('#teachingRoom .toolbar .tool').length;
          if (toolCount >= 5) {
            clearInterval(boardAutoOpenTimer);
            boardAutoOpenTimer = null;
            return;
          }

          const triangleIcon = document.querySelector('#teachingRoom .toolbar .triangle-icon');
          const toolCabinetTrigger = triangleIcon ? triangleIcon.parentElement : null;
          if (toolCabinetTrigger) {
            toolCabinetTrigger.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
            window.setTimeout(() => {
              const boardItem = Array.from(
                document.querySelectorAll('.tool-cabinet-popover .cabinet-item span')
              ).find((node) => /白板|whiteboard/i.test(node.textContent || ''));
              if (boardItem && boardItem.parentElement) {
                boardItem.parentElement.click();
              }
            }, 120);
          }

          if (attempts >= 20) {
            clearInterval(boardAutoOpenTimer);
            boardAutoOpenTimer = null;
          }
        }, 800);
      },
      unloadHandler() {
          let formData = new FormData();
          formData.append('cid',this.$route.params.room);
          formData.append('sid',this.subject_id)
          navigator.sendBeacon(`/api/video/stop`,formData)
      },
    },
    beforeRouteLeave(to, from, next) {
      clearInterval(timer);
      clearInterval(boardAutoOpenTimer);
      this.$api.videoStop({cid: this.$route.params.room, sid: this.subject_id}).then(() => {
        this.$store.commit('updateIsTeaching', false);
        clearInterval(timer);
      })
      next()

    },
    destroyed() {
        // 取消监听
        window.removeEventListener('unload', this.unloadHandler);
        clearInterval(boardAutoOpenTimer);
        

    }


  }
</script>

<style lang="less" scoped>
  #teachingRoom {
    position: relative;
    width: 100%;
    overflow: hidden;
    height: calc(100vh - 82px);
  }

  ::v-deep .fcr-w-screen {
    width: 100% !important;
  }

  ::v-deep .fcr-h-screen {
    height: 100% !important;
  }

  ::v-deep .classroom-viewport {
    width: 100% !important;
    height: 100% !important;
  }

  ::v-deep .toolbar-position {
    right: 10px !important;
    z-index: 30 !important;
  }
</style>
<style lang="less">
  .edu-room {
    height: 100vh;
  }
</style>
